export default __webpack_public_path__ + "static/media/editt.4782e157.svg";